import React, { useState } from "react";
import "./index.scss";
import i18n from "../../locales/i18n";
import { Box, getColor, Typography } from "fds";

const PrivacyPage = ({ height = "100%" }: { height?: string | number }) => {
  const privacyVersionList = ["2014.03.07~2026.05.31", "2026.06.01~"];
  const [version, changeVersion] = useState(0);
  return (
    <Box classes="wsTermsPage" height={height}>
      {i18n.language.includes("ko") ? (
        <Box direction="column" width={"100%"}>
          <iframe
            src={`/cloudportal_privacy_${
              privacyVersionList.length - 1 - version
            }.html`}
            width="100%"
            style={{ border: "none" }}
            title="terms"
            height={height || "640px"}
          />
          <Typography classes="mg mt-12">
            이 전의 개인정보 처리방침은 아래에서 확인할 수 있습니다.
          </Typography>
          {privacyVersionList.reverse().map((item, index) => (
            <Typography
              classes="cursor pointer mg mt-4"
              exactColor={getColor(
                index === version ? "COLOR_TEXT_BRAND" : "COLOR_TEXT_SECONDARY"
              )}
              fontWeight={index === version ? 700 : 400}
              type={index === version ? "body2_underline" : "body2_rg"}
              onClick={() => changeVersion(index)}
            >
              {item}
            </Typography>
          ))}
        </Box>
      ) : (
        <ul>
          <li>
            <h3 className="title">1. General Provisions</h3>
            <p className="contents">
              Personal information is defined as information that identifies an
              individual (including that which can be identified by combining it
              with other information, when it cannot identify an individual with
              the relevant information alone) with items that are included in
              the relevant information about an individual, such as their name
              and resident registration number.
            </p>
            <p className="contents">
              Fasoo Co., Ltd ("the Company") takes customer information
              protection first and closely observes all domestic legislation,
              including the Act on Promotion of Information and Communications
              Network Utilization and Information Protection, etc. ("Information
              and Communications Network Act") and Personal Information
              Protection Act.
            </p>
            <p className="contents">
              The Company's privacy policy provides information regarding the
              purposes and uses of the personal information provided by the
              customer and indicates the kinds of measures that are taken to
              protect the personal information through our privacy policy.
            </p>
            <p className="contents">
              The Company reserves the right to change, amend or modify this
              Privacy Policy of Wrapsody eCo Service ("the Services") in
              accordance with applicable law, regulations, and policies, and, in
              such case, the Company discloses the privacy policy on the Company
              where the customer can find it with ease.
            </p>
          </li>
          <li>
            <h3 className="title">
              2. Items of Collected Personal Information and Methods of
              Collection
            </h3>
            <p className="contents">
              The company collects and processes the following personal
              information to provide basic services.
            </p>
            <ul>
              <li>
                <h4 className="subTitle">
                  ① Personal information to be collected
                </h4>
                <table className="wsTable">
                  <thead>
                    <tr>
                      <th className="th">Information to be collected</th>
                      <th className="th">Purpose of use</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="td">
                        E-mail, name, service usage records, Service suspension
                        records, Service termination records, IP information,
                        access log, Paid plan subscription/ subscription
                        history, billing/payment information and history
                      </td>
                      <td className="td">
                        To secure communication channels to deliver
                        service-related notifications, to confirm the customer's
                        intention, and to handle complaints.
                        <br />
                        To guide new services/products regarding Wrapsody eCo
                        service.
                        <br />
                        To use as basic data for checking service-related errors
                        and handling complaints.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <h4 className="subTitle">
                  ② Methods of collecting personal information
                </h4>
                <p className="contents">
                  Information is collected through the Company's website and log
                  analysis program.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              3. Consent to Collection of Personal Information
            </h3>
            <p className="contents">
              The minimum personal information is collected when a user signs up
              for the Service or while the user uses the Services. In case of
              collecting personal information, the company informs the items to
              collect and purposes to a user in advance. If a customer who wants
              to use the service reads the Terms of Service and this Privacy
              Policy, enters the required items, and clicks the "Complete"
              button for sign-up or checks the "OK" or "I Agree" checkbox, it is
              assumed that the user consents to the processing of personal
              information.
            </p>
          </li>
          <li>
            <h3 className="title">
              4. Retention and Use Period of Personal Information
            </h3>
            <p className="contents">
              When a member withdraws or the purpose of collecting and using
              personal information is achieved, the personal information of the
              member is destroyed without delay. However, it is retained for a
              certain period of time if it is necessary for reasons such as the
              confirmation of the management obligations regarding transaction
              in accordance with the provisions of related laws and regulations
              such as the Commercial Act.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th">Grounds Act</th>
                  <th className="th">Information to be retained.</th>
                  <th className="th">Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce
                  </td>
                  <td className="td">
                    Records on contract or withdrawal of subscription
                  </td>
                  <td className="td">5 year</td>
                </tr>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce, Commercial
                    Law, Basic National Tax Law, Income Tax Law, Corporate Tax
                    Law, VAT Law
                  </td>
                  <td className="td">
                    Records on payment and supply of goods, etc, commercial
                    accounting books and statements of business, and documentary
                    evidences
                  </td>
                  <td className="td">5 year</td>
                </tr>
                <tr>
                  <td className="td">
                    Consumer Protection Act in Electronic Commerce
                  </td>
                  <td className="td">
                    Records of consumer complaints or disputes
                  </td>
                  <td className="td">3 year</td>
                </tr>
                <tr>
                  <td className="td">Communication Secret Protection Act</td>
                  <td className="td">Records of site visits</td>
                  <td className="td">3 month</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">
              5. The Procedure and Methods to Dispose of Personal Information
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">Processes of disposal</h4>
                <p className="contents">
                  Personal information entered by customers for service
                  subscription is deleted or destroyed in accordance with the
                  internal policy and information protection policy according to
                  other related laws after the purpose of use is achieved for
                  reasons such as termination of service. Generally, if there is
                  no debt relationship, personal information collected when
                  registering as a member and managed in the form of an
                  electronic file is immediately deleted upon membership
                  withdrawal.
                </p>
              </li>
              <li>
                <h4 className="subTitle">Methods of disposal</h4>
                <p className="contents">
                  A. Personal information in written documents: shredding,
                  incineration, or chemical decomposition
                </p>
                <p className="contents">
                  B. Personal information in digital file forms: deleted by
                  using technology that prevents the recovery of such records
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              6. The Rights of Members and Legal Representatives and How to
              Exercise the rights
            </h3>
            <p className="contents">
              Registered members and legal representatives can view or modify
              personal information of their own or children under the age of 14
              at any time and may request termination of membership.
            </p>
            <p className="contents">
              The personal information of a member of a child under the age of
              14 can be viewed or modified by clicking Account Information. The
              subscription can be canceled (consent withdrawal) by clicking the
              "Withdrawal of Membership" and going through the identity
              verification process. Or the member can contact the person in
              charge of personal information management by writing, telephone,
              or email, the company will take action without delay.
            </p>
            <p className="contents">
              If you request to correct an error in personal information, the
              personal information will not be used or provided to a third party
              until the correction is completed. If incorrect personal
              information has already been provided to a third party, we will
              notify the third party without delay.
            </p>
            <p className="contents">
              The company handles the personal information that is withdrawn or
              deleted at the request of a member or legal representative as
              described in "4. Retention and Use Period of Personal Information"
              and processes it so that it cannot be viewed or used for other
              purposes.
            </p>
            <p className="contents">
              Please enter your personal information accurately and up to date.
              Members are responsible for accidents caused by incorrect
              information entered by members, and you will lose your
              qualifications for membership if false information such as theft
              of other information is entered.
            </p>
            <p className="contents">
              Members have an obligation not to infringe on other's information
              along with the right to privacy. Be careful not to leak personal
              information of members, including passwords, and be careful not to
              damage other people's personal information, including posts. If
              you damage other people's information, you may be punished by the
              Act on Promotion of Information and Communication Network
              Utilization and Information Protection, etc.
            </p>
          </li>
          <li>
            <h3 className="title">
              7. Technical/organizational Management for the Protection of
              Personal Information
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">Technical measures</h4>
                <p className="contents">
                  FASOO takes the following technical measures to secure the
                  stability of the personal information of our customers, so
                  that there is no loss, theft, leakage, external attack or
                  damage to the information.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      ① The personal information of the customer is secured
                      using passwords, and important data is protected with a
                      special security function by encrypting or locking the
                      file and the transmission data.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② The Company selects the security solution (SSL or SET)
                      for the safe transmission of personal information, using
                      an encrypted algorithm.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ The Company is fully engaged in security matters by
                      using a firewall system and a vulnerability analysis
                      system on each server, to prevent external attacks such as
                      hacking.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">Organizational measures</h4>
                <ul>
                  <li>
                    <p className="contents">
                      ① For the safe protection of personal information, we are
                      operating major systems and facilities with certified
                      information protection management systems by an objective
                      certification body.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ② The Company implemented required processes to access
                      personal information and to manage and ensure the
                      employees are aware of and follow the processes.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ③ The Company shall minimize the number of persons
                      authorized to access personal information on customers as
                      follows.
                    </p>
                    <ul>
                      <li>
                        <p className="contents">
                          a. Those who conduct direct marketing activities
                          toward users
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          b. Those who manage personal information including
                          Privacy Supervisor and Privacy Personnel
                        </p>
                      </li>
                      <li>
                        <p className="contents">
                          c. Those who are obligated to handle personal
                          information due to business
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p className="contents">
                      ④ The Company implemented required processes to access
                      personal information and to manage and ensure the
                      employees are aware of and follow the processes, and holds
                      regular company training and outsourced training for
                      employees who deal with personal information to acquire
                      new security technology and methods of protecting personal
                      information.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑤ Transferring duties and responsibilities between people
                      who handles personal information is performed thoroughly
                      while security is maintained. We clarify where the
                      responsibility lies for personal information accidents
                      after employees leave the company or join the Company.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑥ The computer room and data storage room are set as
                      special protected areas to control access.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑦ When processing a customer's personal information using
                      a computer, a person with access to the personal
                      information is designated and assigned an identification
                      code (ID) and password, and the password is regularly
                      updated.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑧ The company prevents information leakage by employees in
                      advance by requiring new employees to sign the Privacy
                      Protection Pledge when hiring, and establishes and
                      constantly implements internal procedures to audit the
                      implementation of personal information processing policies
                      and compliance with employees.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑨ The company prevents the person who handled the
                      customer's personal information from compromising,
                      infringing, or divulging the personal information by
                      requiring them to sign the Privacy Protection Pledge when
                      they retire.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑩ The Company check the customer's identity when
                      collecting or providing payment information such as credit
                      card numbers and bank settlement accounts for the purpose
                      of signing service contracts and providing services.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑪ The company is not responsible for accidents or events
                      caused by a user's personal mistake or basic internet
                      risk. Each member should appropriately manage own ID and
                      password and be responsible for it for personal
                      information protection. Also, it is recommended to avoid
                      using an easy password that others might be able to guess
                      and to change the password regularly.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑫ When you want to stop using our service while you are
                      logged in to our website on a shared PC, make sure that
                      you have logged out and close the webpage before moving to
                      another website. Otherwise, information such as e-mail and
                      password can be easily leaked to others through the
                      browser.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ⑬ In other cases of personal information loss, disclosure,
                      falsification and damage due to a mistake by an internal
                      managing staff or a technological management accident, the
                      Company will inform you instantly and look for appropriate
                      response and compensation method.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">
                  Restriction on the Use of Personal Data Through External APIs
                </h4>
                <ul>
                  <li>
                    <p className="contents">
                      We do not use user data collected via external APIs,
                      including the Google Workspace API, for the development,
                      improvement, or training of generalized artificial
                      intelligence (AI) and machine learning (ML) models.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              8. Personal Information Management Officer
            </h3>
            <p className="contents">
              We value the Personal Information of our customers and try our
              best not to prevent member's personal information from being
              damaged, infringed, or leaked. In the event of an infringement of
              a member's personal information due to the Company's fault, we
              notify the member in accordance with the procedures and methods
              prescribed by the relevant laws and regulations such as the
              Personal Information Protection Act and the Information and
              Communication Network Act and report to related organization.
              However, the Company is not responsible for information damage by
              unexpected accident caused by basic network threats such as
              hacking occurring despite technological security measures in place
              and disputes over posts written by visitor.
            </p>
            <p className="contents">
              The Company appointed a Personal Information Manager and a
              relevant department as below, to protect the personal information
              of our customers and to take care of any complaints and inquiries
              related to this information.
            </p>
            <table className="wsTable">
              <thead>
                <tr>
                  <th className="th" scope="col"></th>
                  <th className="th" scope="col">
                    Personal Information Manager
                  </th>
                  <th className="th" scope="col">
                    Personal Information Management Staff
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="th" scope="row">
                    Name
                  </th>
                  <td className="td">Young-gil Kim</td>
                  <td className="td">Hyunsu Park</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    Title
                  </th>
                  <td className="td">Managing Director</td>
                  <td className="td">Principal Research Engineer</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    E-mail
                  </th>
                  <td className="td">kimyg@fasoo.com</td>
                  <td className="td">hspark@fasoo.com</td>
                </tr>
                <tr>
                  <th className="th" scope="row">
                    Phone
                  </th>
                  <td className="td" colSpan={2}>
                    82)2-300-9120
                  </td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h3 className="title">9. Obligation for Notification</h3>
            <p className="contents">
              The current privacy policy was revised on March 14, 2025. Should
              there be information to be added, deleted, and edited according to
              government policies or a change in the security technology,
              notification of this will be provided via the website at least
              seven days before the revision.
            </p>
            <p className="contents">
              The privacy policy takes effect on March 14, 2025
            </p>
          </li>
        </ul>
      )}
    </Box>
  );
};

export default PrivacyPage;
